// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"5078dcd6","136":"350e38af","142":"08d45f9d","428":"319182e2","646":"fe090547","709":"a089beb0","940":"da89fd0b"}[chunkId] + ".chunk.js";
};